import React, { useState, useCallback } from 'react';
import { Button, withTheme, Text } from '@rneui/themed';
import { useCollectionItemQuery, useIsEntitledQuery } from '@annunciate/query';
import { DisplayMode, CollectionItemType, } from '@annunciate/core';
import { BuyButton } from '@annunciate/ui/dist/components/buttons/BuyButton';
import { ShareItemButton } from '@annunciate/ui/dist/components/shared/ShareItemButton';
import { Row, FAIcon, View } from '../../elements';
import { IconButton } from '../../buttons';
import { Filter } from './Filter';
import { Sort } from './Sort';
import { TagButton } from '../../tag';
import { PlayCollectionButton } from './PlayCollectionButton';
export const UnthemedActionBar = ({ collection, filter, setFilter, leftBarStyle, rightBarStyle, fullBarStyle, buttonStyle, filterIconStyle, moreIconStyle, textStyle, tagIconSize, tagIconStyle, shareIconSize, shareIconStyle, }) => {
    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const [isSortVisible, setIsSortVisible] = useState(false);
    const isEntitled = useIsEntitledQuery(collection);
    const onToggleFilter = useCallback(() => {
        setIsFilterVisible(!isFilterVisible);
    }, [isFilterVisible]);
    const onToggleSort = useCallback(() => {
        setIsSortVisible(!isSortVisible);
    }, [isSortVisible]);
    const { data: collectionItems, fetchNextPage, } = useCollectionItemQuery({
        parentId: collection.id,
        displayMode: DisplayMode.SERIES,
        terminatingTypes: [CollectionItemType.Collection],
        shouldObserveUser: collection.isUserDependent,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Filter, { parent: collection, selected: filter?.collection, items: collectionItems, isVisible: isFilterVisible, onToggleOverlay: onToggleFilter, onLoadMore: fetchNextPage, setFilter: (collection) => setFilter(({
                ...filter,
                collection: collection,
            })) }),
        React.createElement(Sort, { isVisible: isSortVisible, onToggleVisible: onToggleSort, filter: filter.playbackState, sort: {
                order: filter.sortOrder,
                field: filter.sortField,
            }, onFilterSelected: (playbackState) => setFilter(({
                ...filter,
                playbackState
            })), onSortSelected: (sort) => setFilter(({
                ...filter,
                sortOrder: sort.order,
                sortField: sort.field,
            })) }),
        React.createElement(Row, { style: fullBarStyle },
            React.createElement(Row, { style: leftBarStyle },
                React.createElement(View, { style: { marginRight: 30, backgroundColor: 'transparent' } }, isEntitled === true ? (React.createElement(PlayCollectionButton, { collection: collection })) : (React.createElement(BuyButton, { item: collection }))),
                React.createElement(TagButton, { item: collection, size: tagIconSize, iconStyle: tagIconStyle }),
                React.createElement(ShareItemButton, { item: collection, size: shareIconSize, iconStyle: shareIconStyle })),
            React.createElement(Row, { style: rightBarStyle },
                React.createElement(Button, { touchSoundDisabled: true, disabled: collectionItems?.length <= 1, disabledStyle: { opacity: 0, backgroundColor: 'transparent' }, buttonStyle: buttonStyle, onPress: onToggleFilter, title: (React.createElement(Row, null,
                        React.createElement(Row, { style: leftBarStyle },
                            React.createElement(Text, { numberOfLines: 1, style: textStyle }, filter.collection.id === collection.id ? 'All' : filter.collection.name)),
                        React.createElement(Row, { style: rightBarStyle },
                            React.createElement(FAIcon, { name: "chevron-down", style: filterIconStyle })))) }),
                React.createElement(IconButton, { onPress: () => onToggleSort(), activeIconName: "ellipsis-v", nonActiveIconName: "ellipsis-v", style: moreIconStyle, isRightAligned: true })))));
};
export const ActionBar = withTheme(UnthemedActionBar, 'ActionBar');
//# sourceMappingURL=ActionBar.js.map